module.exports = __webpack_public_path__ + "static/media/sim.10470c68.gif";